// extracted by mini-css-extract-plugin
export var list = "List-module--list--23a2e";
export var item = "List-module--item--005de";
export var itemWrapper = "List-module--itemWrapper--fb8c1";
export var checked = "List-module--checked--d4ffb";
export var colored = "List-module--colored--e3135";
export var white = "List-module--white--a095f";
export var lg = "List-module--lg--e56bf";
export var md = "List-module--md--88a10";